import moment from "moment";
import styled from "styled-components";
import { calcRem } from "styles/theme";
import { COLORS } from "styles/colors";
import { CHART_MARGIN_TOP, CHART_MARGIN_BOTTOM } from "utils/ChartUtil";

const GRAPH_CONTENT_HEIGHT = 200;
export const PAY_DAY_LINE_Y2 = -(
  GRAPH_CONTENT_HEIGHT -
  CHART_MARGIN_TOP -
  CHART_MARGIN_BOTTOM
);
const LABEL_W = 84;
const LABEL_H = 18;
const LABEL_Y = -(LABEL_H + 6);
const TODAY_LABEL_Y = PAY_DAY_LINE_Y2 - LABEL_H / 2;

export interface AxisPayDayTickProps {
  x: number;
  y: number;
  value: string | number;
  textY: number;
  paymentDueDateTick: string | null;
  payDayDD?: string | null;
  todayTick?: string | null;
}

export function AxisPayDayTick({
  x,
  y,
  value,
  textY,
  paymentDueDateTick,
  payDayDD,
  todayTick,
}: AxisPayDayTickProps) {
  const isPayDay = !!paymentDueDateTick && String(value) === paymentDueDateTick;
  const isToday = !isPayDay && !!todayTick && String(value) === todayTick;
  const dd =
    isPayDay && payDayDD
      ? payDayDD
      : moment(value as string).format("DD");
  const labelCenterX = 0;

  return (
    <g transform={`translate(${x},${y})`}>
      {isPayDay && (
        <>
          {/* <PayDayLine
            x1={0}
            y1={0}
            x2={0}
            y2={PAY_DAY_LINE_Y2}
            strokeDasharray="4 2"
            strokeWidth={1}
          /> */}
          <PayDayRect
            x={labelCenterX - LABEL_W / 2}
            y={LABEL_Y}
            width={LABEL_W}
            height={LABEL_H}
            rx={4}
          />
          <PayDayArrow
            points={`${labelCenterX - 4},${LABEL_Y + LABEL_H} ${
              labelCenterX + 4
            },${LABEL_Y + LABEL_H} ${labelCenterX},0`}
          />
          <PayDayLabelText
            textAnchor="middle"
            dominantBaseline="hanging"
            x={labelCenterX}
            y={LABEL_Y + 4}
          >
            Payment Due
          </PayDayLabelText>
        </>
      )}
      {isToday && (
        <>
          <TodayLine
            x1={0}
            y1={0}
            x2={0}
            y2={PAY_DAY_LINE_Y2}
            strokeDasharray="2 2"
            strokeWidth={1}
          />
          <TodayRect
            x={-LABEL_W / 2}
            y={TODAY_LABEL_Y}
            width={LABEL_W}
            height={LABEL_H}
            rx={LABEL_H / 2}
          />
          <TodayLabelText
            textAnchor="middle"
            dominantBaseline="hanging"
            x={0}
            y={TODAY_LABEL_Y + 4}
          >
            Today
          </TodayLabelText>
        </>
      )}
      <TickText
        textAnchor={"middle"}
        dominantBaseline="hanging"
        x={0}
        y={textY}
        $isPayDay={isPayDay}
        $isToday={isToday}
      >
        {dd}
      </TickText>
    </g>
  );
}

const PayDayLine = styled.line`
  stroke: ${({ theme }) => theme.COLORS.BORDER};
`;

const PayDayRect = styled.rect`
  fill: ${COLORS.BLACK};
`;

const PayDayArrow = styled.polygon`
  fill: ${COLORS.BLACK};
`;

const PayDayLabelText = styled.text`
  font-size: ${calcRem(12)};
  font-weight: 500;
  fill: ${COLORS.GREEN};
`;

const TodayLine = styled.line`
  stroke: ${COLORS.BUTTONS2};
  opacity: 0.6;
`;

const TodayRect = styled.rect`
  fill: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : COLORS.PRIMARY2};
  stroke: ${COLORS.BUTTONS2};
  stroke-width: 1;
`;

const TodayLabelText = styled.text`
  font-size: ${calcRem(12)};
  font-weight: 500;
  fill: ${COLORS.BUTTONS2};
`;

const TickText = styled.text<{ $isPayDay: boolean; $isToday: boolean }>`
  font-size: ${calcRem(12)};
  font-weight: ${({ $isPayDay, $isToday }) =>
    $isPayDay || $isToday ? 700 : 400};
  fill: ${({ theme, $isPayDay, $isToday }) =>
    $isPayDay
      ? COLORS.GREEN
      : $isToday
      ? COLORS.BUTTONS2
      : `${theme.COLORS.WHITE}80`};
`;
